import React, { useEffect, useState, useRef } from 'react';
import PageContainerAB from '../../components/PageContainerAB/pageContainer';
import styles from './styles.module.css';
import ContainerSelector from './ContainerSelector';
import AutobookList from './AutobookList';
import { noScroll } from '@/actions/Helper';
import CustomSwitch from '@/components/CostomSwitch/CustomSwitch';

export default () => {
  const [clickConatiner, setClickConatiner] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [autobookAppointmentsApiData, setAutobookAppointmentsApiData] =
    useState([]);
  const [settings, setSettings] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [savedTemplates, setSavedTemplates] = useState([]);
  const [status, setStatus] = useState('DISABLED');
  const [reLoadAutobook, setReLoadAutobook] = useState(false);
  const [saving_identifier, setSaving_identifier] = useState('');
  const [loading, setLoading] = useState(false);
  const [fixed, setFixed] = useState(false);
  const [showSavePreferences, setShowSavePreferences] = useState(false);
  const [selectedContainers, setSelectedContainers] = useState([]);
  const [selectedContainer, setSelectedContainer] = useState(null);
  const [autobookMode, setAutobookMode] = useState({
    status: false,
    autobookId: null,
  });
  const [autobookModeLoading, setAutobookModeLoading] = useState(false);
  const [loadOn, setLoadOn] = useState(false);
  const [activeSection, setActiveSection] = useState('hour');
  const [preferenceName, setPreferenceName] = useState('');
  const [reLoadAutobookContainer, setReLoadAutobookContainer] = useState(false);
  const [clickedTemplate, setClickedTemplate] = useState(null);
  const [activeTab, setActiveTab] = useState('available');
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [collapsedRow, setCollapsedRow] = useState(false);
  const [ABloading, setABloading] = useState(false);
  const [trackingUrl, setTrackingUrl] = useState('');

  // Ref for autobookContainer
  const autobookContainerRef = useRef(null);

  // State for AutobookList width only
  const [autobookListWidth, setAutobookListWidth] =
    useState('calc(100% - 630px)');

  // Function to calculate AutobookList width only
  const calculateAutobookListWidth = () => {
    if (!autobookContainerRef.current) return;

    const containerWidth = autobookContainerRef.current.offsetWidth;

    // Get the actual width of the ContainerSelector (first child)
    const containerSelectorElement =
      autobookContainerRef.current.firstElementChild;
    const actualContainerSelectorWidth = containerSelectorElement
      ? containerSelectorElement.offsetWidth
      : 630;

    // Calculate remaining width for AutobookList
    const remainingWidth = containerWidth - actualContainerSelectorWidth;

    setAutobookListWidth(`${remainingWidth}px`);
  };

  // Calculate AutobookList width based on parent container width minus ContainerSelector width
  useEffect(() => {
    // Calculate on mount and window resize with a small delay to ensure container is rendered
    const timeoutId = setTimeout(calculateAutobookListWidth, 100);
    window.addEventListener('resize', calculateAutobookListWidth);

    // Use ResizeObserver for more responsive width changes
    let resizeObserver;
    if (autobookContainerRef.current && window.ResizeObserver) {
      resizeObserver = new ResizeObserver(calculateAutobookListWidth);
      resizeObserver.observe(autobookContainerRef.current);
    }

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', calculateAutobookListWidth);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [clickConatiner, selectedContainer, tableData, collapsedRow]); // Recalculate when container is clicked or data changes

  // Additional effect to recalculate after ContainerSelector width changes
  useEffect(() => {
    const timeoutId = setTimeout(calculateAutobookListWidth, 50);
    return () => clearTimeout(timeoutId);
  }, [clickConatiner, collapsedRow]); // Trigger when container selection changes

  const handleScroll = (body) => {
    if (body.target?.scrollTop > 100) {
      setFixed(true);
    } else {
      setFixed(false);
    }
  };

  return (
    <PageContainerAB
      stretchHeaderToScrollWidth
      minWidth={'auto'}
      title="Autobook Preferences"
      mainPage={true}
      handleScroll={(body) => handleScroll(body)}>
      <div ref={autobookContainerRef} className={styles.autobookContainer}>
        <ContainerSelector
          loading={loading}
          setLoading={setLoading}
          clickConatiner={clickConatiner}
          setClickConatiner={setClickConatiner}
          setTableData={setTableData}
          setAutobookAppointmentsApiData={setAutobookAppointmentsApiData}
          setHistoryList={setHistoryList}
          setSettings={setSettings}
          setStatus={setStatus}
          setSaving_identifier={setSaving_identifier}
          selectedContainers={selectedContainers}
          setSelectedContainers={setSelectedContainers}
          selectedContainer={selectedContainer}
          setSelectedContainer={setSelectedContainer}
          savedTemplates={savedTemplates}
          setSavedTemplates={setSavedTemplates}
          reLoadAutobook={reLoadAutobook}
          setReLoadAutobook={setReLoadAutobook}
          setShowSavePreferences={setShowSavePreferences}
          showSavePreferences={showSavePreferences}
          autobookMode={autobookMode}
          setAutobookMode={setAutobookMode}
          setLoadOn={setLoadOn}
          loadOn={loadOn}
          reLoadAutobookContainer={reLoadAutobookContainer}
          setReLoadAutobookContainer={setReLoadAutobookContainer}
          setActiveSection={setActiveSection}
          activeSection={activeSection}
          clickedTemplate={clickedTemplate}
          setClickedTemplate={setClickedTemplate}
          preferenceName={preferenceName}
          setPreferenceName={setPreferenceName}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          actionMenuAnchor={actionMenuAnchor}
          setActionMenuAnchor={setActionMenuAnchor}
          collapsedRow={collapsedRow}
          setCollapsedRow={setCollapsedRow}
          trackingUrl={trackingUrl}
          setTrackingUrl={setTrackingUrl}
        />
        <AutobookList
          autobookModeLoading={autobookModeLoading}
          setAutobookModeLoading={setAutobookModeLoading}
          loading={loading}
          setLoading={setLoading}
          ABloading={ABloading}
          setABloading={setABloading}
          width={autobookListWidth}
          clickConatiner={clickConatiner}
          tableData={tableData}
          autobookAppointmentsApiData={autobookAppointmentsApiData}
          setTableData={setTableData}
          setAutobookAppointmentsApiData={setAutobookAppointmentsApiData}
          settings={settings}
          historyList={historyList}
          setHistoryList={setHistoryList}
          setSavedTemplates={setSavedTemplates}
          setSettings={setSettings}
          saving_identifier={saving_identifier}
          status={status}
          setStatus={setStatus}
          setSaving_identifier={setSaving_identifier}
          selectedContainers={selectedContainers}
          selectedContainer={selectedContainer}
          savedTemplates={savedTemplates}
          setReLoadAutobook={setReLoadAutobook}
          setShowSavePreferences={setShowSavePreferences}
          showSavePreferences={showSavePreferences}
          autobookMode={autobookMode}
          setAutobookMode={setAutobookMode}
          setLoadOn={setLoadOn}
          loadOn={loadOn}
          reLoadAutobookContainer={reLoadAutobookContainer}
          setReLoadAutobookContainer={setReLoadAutobookContainer}
          setSelectedContainers={setSelectedContainers}
          setSelectedContainer={setSelectedContainer}
          setClickConatiner={setClickConatiner}
          setActiveSection={setActiveSection}
          activeSection={activeSection}
          clickedTemplate={clickedTemplate}
          setClickedTemplate={setClickedTemplate}
          preferenceName={preferenceName}
          setPreferenceName={setPreferenceName}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          actionMenuAnchor={actionMenuAnchor}
          setActionMenuAnchor={setActionMenuAnchor}
          collapsedRow={collapsedRow}
          setCollapsedRow={setCollapsedRow}
          trackingUrl={trackingUrl}
          setTrackingUrl={setTrackingUrl}
        />
      </div>
    </PageContainerAB>
  );
};
